var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNobilan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 0,
    y: 0,
    width: 81,
    height: 60,
    rx: 10.636
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-60.5%",
    y: "-68.3%",
    width: "221%",
    height: "263.3%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.870588235 0 0 0 0 0.88627451 0 0 0 0 0.898039216 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F5F8",
    x: 14,
    y: 29,
    width: 53,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4A90E2",
    x: 14,
    y: 12,
    width: 11,
    height: 11,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F5F8",
    x: 14,
    y: 37,
    width: 32,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F5F8",
    x: 14,
    y: 45,
    width: 45,
    height: 3,
    rx: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNobilan);
export default __webpack_public_path__ + "static/media/nobilan.ae064e90134d589b67aa5b619eb75f62.svg";
export { ForwardRef as ReactComponent };